import type { SendResultLimitKind, SendResultTruncation } from '@/model/Agent.model';
import { formatCount } from './SendText';

/**
 * What each configured result limit bounds, in plain words. Typed by the generated union, so a limit
 * the server adds without copy here fails to compile rather than appearing as a token.
 */
export const LIMIT_TEXT: Record<SendResultLimitKind, string> = {
  findings_per_rule: 'Examples kept for each rule',
  findings_per_result: 'Examples kept for the whole report',
  findings_per_domain_group: 'Examples kept for each set of domains in the cross-domain checks',
  row_finding_collapse_threshold: 'Findings on many rows combined into one',
  distinct_invalid_values_per_column: 'Different invalid values listed for each column',
  unmatched_headers_per_file: 'Unrecognised column names listed for each file',
  serialised_result_bytes: 'Size of the stored report',
};

/** Where a limit applied, as a reader would say it. */
const scopeText = (scope: string): string => (scope === 'result' ? 'the whole report' : scope);

/** One limit that bit, as a sentence: what it bounds, where, its value, and how much it left out. */
export const truncationText = (truncation: SendResultTruncation): string =>
  `${LIMIT_TEXT[truncation.limit] ?? truncation.limit} (${scopeText(truncation.scope)}): limited to ` +
  `${formatCount(truncation.limit_value)}, so ${formatCount(truncation.omitted)} left out`;
